import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth, type UserRole } from "@/lib/auth";

interface Props {
  children: ReactNode;
  /** If provided, user must have one of these roles. */
  requireRole?: UserRole[];
}

/**
 * Redirects unauthenticated users to /login and users without the required
 * role to /monitor (the default safe landing page).
 */
export default function ProtectedRoute({ children, requireRole }: Props) {
  const location = useLocation();
  const token = useAuth((s) => s.token);
  const user = useAuth((s) => s.user);

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireRole && !requireRole.includes(user.role)) {
    return <Navigate to="/monitor" replace />;
  }

  return <>{children}</>;
}
